export default {
  count: 0,
  popupVisible: false,
  keyword: '',
  scrollTop: 0,
  loadingShow: false,
  user: {
    auth: '',
    auth2: '',
    name: '',
    userId: '',
    userType: '',
    level: '',
    email: '',
    realName: ''
  },
  authInfo: {
    userType: '',
    userId: 0,
    name: '',
    gender: 0,
    hospitalId: 0,//单位ID
    hospital: '', //单位
    department: '', //部门
    title: '', //医生认证职称
    mail: '', //医生认证邮箱
    //企业认证
    departmentStr: '', //企业认证部门
    idCards: [{
      url: '',
      preUrl: '',
      name: '',
      // picType 1为资格证 2 为执业证
      picType: 1
    }], //上传图片信息
    titleStr: '', //企业认证职称
    email: '',
    //学生认证
    universityName: '',
    majorId: 0,
    majorName: '',
    prov: '', // 省
    provId: '',
    city: '', // 市
    cityId: '',
    typeChild: '', // 具体身份
    degree: '', // 学历
    enrollmentYear: '', //入学年份
    doctorCertificateNo: null,
    diseases: []
  },
  userInfo: {
    basic: {
      level: 0 //认证类型 0: 未登录用户 1: 登录但未验证用户 2: 登录且已验证用户 3:验证未通过 4:正在验证状态中
    },
    userType: 0

  },
  // 个人信息也使用   页面为userInfo
  personalInfo: {
    sequenceId: '',
    EsequenceId: '',
    level: '',
    headPortraitUrl: '',
    name: '',
    gender: 1,
    mobile: '',
    email: '',
    introduction: '',
    userType: 0,
    typeChild: '',
    realName: '',
    prov: '',
    provId: '',
    city: '',
    cityId: '',
    universityId: 0,
    universityName: '', // 学校名称
    companyId: '',      // 公司ID, 医院ID
    companyName: '',    // 公司名称, 单位(6), 医院名称
    degree: '',      // 学历
    enrollYear: '',  // 入学年份
    majorId: '',     // 专业ID
    majorName: '',   // 专业名称
    deptId: '',      // 部门ID, 科室ID,
    deptName: '',    // 部门名称，科室名称
    deptTitleId: '', // 职位ID, 职称ID
    deptTitle: '',    // 职位名称, 职称名称,
    diseases: [], //擅长瘤种
    userId: 0 //用户id
  },
  privilageInfo: {
    privilageCode: '',
    privilageMsg: ''
  },
  originLiveUrl: '',
  jurisdictionHospital: '', //权限 选择医院
  jurisdictionRealName: '',  //权限 真是姓名
  jurisdictionDeptName: '', //权限 科室
  jurisdictionUniversityName: '',// 权限  选择学校
  jurisdictionmajorName: '',// 权限  选择专业
  jurisdictionDocid: '', //权限  返回的文章id
  jurisdictionDoctype: '', //权限  返回的文章类型
  jurisdictionpath: 0,// 权限 0是从选择身份进入 内容填写
  audioprogress: 0,
  caseId: 0,//挑战赛病例id
  answerRecordId: 0,//挑战赛答题id
  AZitems: 0,
  isRigisterTwo: false,
  iscomplete: 1,//登录后判断用户信息是否完整
  completepath: '',//登录完善信息前的 路由
  onlyLackDisease: 0,//登录后判断用户信息是否只少瘤种
  //EDC 元数据
  EDCSourceData: {
    project: {
      projectCode: '',
      id: 0
    }
  },
  EDCpatient: {
    id: 0,
    patientName: '',
    projectId: '',
    gender: '',
    mobile: '',
    wechat: '',
    hospitalNo: '',
    idCard: '',
    birthday: null,
    patientNo: ''
    // birthdayData:null,
  },
  EDCSubproject: {
    projectCode: '',
    id: 0
  },
  //EDC医生用户信息
  EDCDoctorInfo: {
    id: '',//新建用户的话，为null
    name: '',//姓名
    idCardNum: '',//身份证号
    hospital: '',//医院名
    hospitalId: 0,//医院id
    departmentId: '', //科室id
    departmentStr: '',//科室名字
    // titleId: 0, //职称id
    // titleStr: '',//职称名字
    province: '',//省份名
    provinceId: '',//省份id
    city: '',//城市名字
    cityId: '',//城市id
    idCardFrontUrl: '',//身份证正面照片
    idCardFrontKey: '',//身份证正面照片对应的key值
    idCardBackUrl: '',//身份证反面照片
    idCardBackKey: '',//身份证反面照片对应的key值
    bankInfo: {
      name: '',//开户银行名字（具体到支行）
      number: '',//银行卡号
      province: '',//开户行地区-省份名
      provinceId: '',//开户行地区-省份id
      city: '',//开户行地区-城市名字
      cityId: ''//城市id
    },
    doctorLicenceUrl: '',//执业证照片
    doctorLicenceKey: '',//执业证照片对应的key值
    otherDataKeys: [],//认证第四步，其他图片的key
    otherDataUrls: []//认证第四步，其他图片的url
  },
  //互联网医院申请入驻的用户信息
  IHApplyUserInfo: {
    // id: '',//新建用户的话，为null
    // status: null,//申请状态
    // userType: 0,//用户身份类型
    // realName: '',//真实姓名
    // mobileNum: '',//手机号
    // companyName: '',//工作单位(医生或者科研工作者，其他的身份是不可以申请的，走不下去)
    // companyId: 0,//工作单位id
    // titleId: 0, //职称id
    // titleName: '',//职称名字

    status: -1,//对单病种中心的申请情况  -1:从未申请过  0：未处理（处理中）  1：服务认证  2: 执业认证 3：驳回   1001:自定义的--表示已经有单病种申请成功了的
    rejectReason:'',//驳回理由

    diseaseCenterId: 0,//选择的单病种中心的id
    diseaseCenterName: '',//选择的单病种中心名

    diseaseTeamName: '',//申请入驻的团队名

    idCardFrontUrl: '',//身份证正面照片
    // idCardFrontKey: '',//身份证正面照片对应的key值
    idCardBackUrl: '',//身份证反面照片
    // idCardBackKey: '',//身份证反面照片对应的key值

    docMedical1PicUrl: '',//医师资格证照片第一页
    // doctorMedical1PicKey: '',//医师资格证照片第一页的key值
    docMedical2PicUrl: '',//医师资格证照片第二页
    // doctorMedical2PicKey: '',//医师资格证照片第二页的key值

    docOperate1PicUrl: '',//执业证照片第一页
    // doctorPart1PicKey: '',//执业证照片第一页的key值
    docOperate2PicUrl: '',//执业证照片第二页
    // doctorPart2PicKey: '',//执业证照片第二页的key值

    docWorkPicUrl: '',//医师职称证第一页
    // doctorWorkPicKey: ''//医师职称证第一页的key值
  },
  customLimitTimeTask:{}
}
